import React from 'react';

export default {
  width: 20,
  height: 20,
  content: (
    <path
      d="M10 0L12.3567 7.63827H20L13.8217 12.3619L16.1784 20L10 15.2764L3.82166 20L6.17835 12.3619L0 7.63827H7.6327L10 0Z"
    />
  )
};
